import React from "react";
import { ReactComponent as Arrow } from "svgs/middle-size-arrow.svg";
import { Swiper, SwiperSlide } from "components/swiper";
import { FreeMode, Navigation } from "swiper/modules";
import { trackSelectItem } from "analytics";
import Link from "components/link";
import { useCart, useCustomer, useSettings } from "hooks/useStore";
import Skeleton from "components/loader/cart/upsells";

const CartUpsells = ({ swiperSettings = {} }) => {
	const { toggleCart, isCartOpen } = useSettings(["toggleCart", "isCartOpen"]);
	const { recommendations } = useCart(["recommendations"]);
	const customer = useCustomer();

	const handleProductClick = (product, index) => {
		trackSelectItem({ ...product, index }, customer, "cart_you_may_also_like");
		isCartOpen && toggleCart();
	};

	if (!recommendations) return <Skeleton />;

	if (!recommendations?.length) return null;

	return (
		<div className="cart-upsells">
			<div className="w-full flex justify-between">
				<p className="text-base font-bold">You may also like</p>
				<div className="flex gap-5 items-center">
					<div className="left-arrow-top">	<Arrow className="rotate-180 fill-black" /></div>
					<div className="right-arrow-top"> <Arrow className="fill-black" /></div>
				</div>
			</div>
			<div className="flex flex-nowrap gap-4 overflow-hidden">
				<Swiper
					spaceBetween={16}
					slidesPerView={Math.min(recommendations.length, 3)}
					modules={[FreeMode, Navigation]}
					centerInsufficientSlides
					mousewheel={{ enabled: true, forceToAxis: true }}
					navigation={{ enabled: true, nextEl: ".right-arrow-top", prevEl: ".left-arrow-top" }}
					breakpoints={{ 768: { spaceBetween: 20 } }}
					className="py-4 w-full m-0"
					{...swiperSettings}
				>
					{recommendations.map((product, index) => (
						<SwiperSlide key={index} className="cursor-pointer w-1/4 max-w-48 xxl:max-w-[25%]">
							<Link
								onClick={() => handleProductClick({ ...product, position: index + 1 })}
								to={`/products/${product?.handle}`} className="group/card flex flex-col gap-1 w-auto">
								<img src={product.image.src} alt={product.image.alt} loading="lazy" />
								<p className="text-sm">{product?.title}</p>
							</Link>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</div>
	);
};

export default CartUpsells;